// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__2Aigk","hide":"loader_hide__2bg0m","loader-body":"loader_loader-body__373t6","loader":"loader_loader__3YnrM","load5":"loader_load5__1YU_V"};